import { FC } from 'react';
import type { SearchFilters } from 'state/search/reducer';
import { useTranslation } from 'utils/i18n';
import SearchQuery from './searchQuery';

interface Props {
  previousSearches?: SearchOptions[];
  onClick: (options: SearchOptions) => void;
}

// A stored search is a snapshot of the search filters, so this stays derived
// from them (including their `null`-means-unset convention).
export type SearchOptions = Partial<
  Pick<
    SearchFilters,
    'location' | 'property' | 'distance' | 'capacity' | 'facets'
  >
>;

const PreviousSearches: FC<Props> = ({ previousSearches = [], onClick }) => {
  const { t } = useTranslation('common');
  const hasPreviousSearches = previousSearches.length > 0;

  return (
    hasPreviousSearches && (
      <div className="previous-searches">
        <div className="previous-searches__title">
          <h3>{t('previous_searches.title')}</h3>
        </div>

        <div className="previous-searches__inner">
          <ul className="previous-searches__list">
            {previousSearches.map((search, index) => (
              <SearchQuery
                key={`${search.location}-${search.distance}-${search.capacity}-${index}`}
                options={search}
                onClick={onClick}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  );
};

export default PreviousSearches;
